import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, CircularProgress } from '@material-ui/core';
import { TEXT } from '../../shared_components';

const RaiseInvoiceDialog = ({ plan, loading, onClose, onSubmit }) => {
  const [invoiceRefNo, setInvoiceRefNo] = useState('');

  return (
    <Dialog open onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h6" style={{ fontWeight: 700 }}>Raise Invoice</Typography>
        <Typography variant="body2" style={{ color: TEXT.secondary, marginTop: 2 }}>{plan?.name}</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth required autoFocus size="small" variant="outlined" label="Invoice Ref No."
          placeholder="INV-2026-0041" InputLabelProps={{ shrink: true }}
          value={invoiceRefNo} onChange={(event) => setInvoiceRefNo(event.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ padding: '12px 24px' }}>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button
          variant="contained" color="primary" disabled={!invoiceRefNo.trim() || loading}
          onClick={() => onSubmit(invoiceRefNo.trim())}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Raise Invoice'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RaiseInvoiceDialog;
